<template>
  <!--<v-app class="grey lighten-3">-->
  <v-app class="secondary">
    <template v-if="!loggedIn" class="">
      <router-view></router-view>
    </template>
    <template v-if="loggedIn" class="">
      <v-navigation-drawer width="230" app fixed dark class="nav-scrl navigation primary nav-ico" v-model="sideNav">
        <v-list class="pt-4">
          <v-list-tile class="hidden-lg-only hidden-md-only hidden-sm-only">
            <div class="text-xs-left">
              <v-flex xs12 class=" mr-3 ml-3 translate-box">

                <v-select
                  solo
                  prepend-inner-icon="g_translate"
                  background-color="white"
                  class="text-grey f-10"
                  v-model="select"
                  :items="items"
                  item-text="state"
                  label="Select"
                ></v-select>
              </v-flex>
            </div>
          </v-list-tile>
          <v-list-tile to="/">
            <v-list-tile-action class="text-white">
              <!-- <v-icon class="f-18">home</v-icon> -->
               <v-icon class="f-18">fas fa-tachometer-alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="text-white">Dashboard</v-list-tile-content>
          </v-list-tile>

          <v-list-tile to="/customers">
            <v-list-tile-action class="text-white">
              <v-icon class="f-18">people</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="text-white">Customers</v-list-tile-content>
          </v-list-tile>

           <v-list-tile to="/addnewcustomers">
            <v-list-tile-action class="text-white">
              <!-- <v-icon class="f-18">add_circle_outline</v-icon> -->
              <i class="fas fa-user-plus"></i>
            </v-list-tile-action>
            <v-list-tile-content class="text-white">Add Customer</v-list-tile-content>
          </v-list-tile>
          
          <v-list-tile to="/logs">
            <v-list-tile-action class="text-white">
              <v-icon class="f-18">list_alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="text-white">Logs</v-list-tile-content>
          </v-list-tile>

          <v-list-tile to="/earnings">
            <v-list-tile-action class="text-white">
              <v-icon class="f-15">far fa-credit-card</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="text-white">Earnings</v-list-tile-content>
          </v-list-tile>

          <v-list-tile to="/examstab">
            <v-list-tile-action class="text-white">
              <!-- <v-icon class="f-15">featured_play_list</v-icon> -->
              <v-icon class="f-15 pl-1">fas fa-book</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="text-white">Exams</v-list-tile-content>
          </v-list-tile>


          <v-list-group prepend-icon="class" >
            <v-list-tile class="text-white" slot="activator">
              <v-list-tile-title class="text-white">Classes</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/classes" class="pl-2 white--text">
              <v-list-tile-action>
                <!-- <v-icon class="white--text f-15">fas fa-tachometer-alt</v-icon> -->
                <i class="fas fa-list white--text"></i>
                <!--<v-icon class="white&#45;&#45;text">fa-credit-card</v-icon>-->
              </v-list-tile-action>
              <v-list-tile-title class="white--text f-12">Classes List</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/CreateClass" class="pl-2">
              <v-list-tile-action>
                <!-- <v-icon class="white--text f-18">add</v-icon> -->
                <i class="fa fa-plus-circle  white--text"></i>
              </v-list-tile-action>
              <v-list-tile-title class="white--text">Add Class</v-list-tile-title>
            </v-list-tile>

          </v-list-group>

          <v-list-group prepend-icon="view_module" >
            <v-list-tile class="text-white" slot="activator">
              <v-list-tile-title class="text-white">Packages</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/packages" class="pl-2 white--text">
              <v-list-tile-action>
                <!-- <v-icon class="white--text f-15">fas fa-tachometer-alt</v-icon> -->
                <i class="fas fa-list white--text"></i>
              </v-list-tile-action>
              <v-list-tile-title class="white--text f-12">Packages List</v-list-tile-title>
            </v-list-tile>

            <v-list-tile to="/createpackage" class="pl-2">
              <v-list-tile-action>
                <!-- <v-icon class="white--text f-18">add</v-icon> -->
                <i class="fa fa-plus-circle  white--text"></i>
              </v-list-tile-action>
              <v-list-tile-title class="white--text f-12">Add Package</v-list-tile-title>
            </v-list-tile>

          </v-list-group>

          <v-list-tile to="/policemans">
            <v-list-tile-action class="text-white">
              <v-icon class="f-15">far fa-id-card</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="text-white">Police Stations</v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="deleted = true">
            <v-list-tile-action class="text-white">
              <v-icon class="f-15 ml-1">fas fa-sign-out-alt</v-icon>
            </v-list-tile-action>
            <v-list-tile-content class="text-white">Logout</v-list-tile-content>
          </v-list-tile>
        </v-list>
        <!--<v-flex class="fixed-bottom bottom-0 pa-2">-->
          <!--<v-btn block outline class="grey text-white">Logout<v-icon class="f-15 pl-2">fas fa-sign-out-alt</v-icon></v-btn>-->
        <!--</v-flex>-->
      </v-navigation-drawer>
      <v-dialog v-model="deleted" max-width="290">
        <v-card class="card-r">
          <v-card-title class="f-18 text-capitalize">Are you sure want to logout?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="grey text-white left" text @click="deleted = false">No</v-btn>
            <v-btn class="primary text-white" @click="logout" text >Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-toolbar fixed app class="primary pr-3 " dark>
        <v-toolbar-side-icon @click.stop="ChangeSidebar"></v-toolbar-side-icon>
        <img class="Toolbarlogo ml-1" small src="/static/logo2.png"/>
        <v-toolbar-items>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <div class="hidden-xs-only right">
          <v-flex xs12 lg6 class=" mr-2 ml-3 translate-box right">
            <v-select solo
                      prepend-inner-icon="g_translate"
                      background-color="white"
                      class="text-grey no-shadow f-12"
                      v-model="select"
                      :items="items"
                      item-text="state"
                      label="Select"
            ></v-select>
          </v-flex>
        </div>
        <router-link to="/profile">
          <v-tooltip bottom>
            <v-avatar :size="24" slot="activator" to="/profile" class="mr-2">
              <img class="white-r-border object-fit" v-bind:src="user.image" :onchange="true" >
            </v-avatar>
            <span>My profile</span>
          </v-tooltip>
        </router-link>
        <v-btn small class="" icon @click.stop="drawer = !drawer">
          <v-icon class="NotiColor f-20">fas fa-bell</v-icon>
        </v-btn>
        <!-- <v-menu max-width="600"
                v-model="menu"
                bottom
                v-on="on"
                offset-y
                :nudge-width="300"
                offset-x
                class="right"
        >
          <template v-slot:activator="{ on }">
            <v-btn small class="white" icon v-on="on">
              <v-icon class="textColor f-28">public</v-icon>
            </v-btn>
          </template> -->
          <!-- <div style="height:500px !important;"> -->
            <!-- <v-card v-for="Admin in AdminRequest" :key="Admin.id">
               <v-list >
                 <v-list-tile avatar>
                   <v-list-tile-avatar>
                     <v-img v-bind:src="Admin.user_image"> </v-img>
                   </v-list-tile-avatar>
                   <v-list-tile-content>
                     <v-list-tile-title>{{Admin.message}}</v-list-tile-title>
                     <v-list-tile-sub-title> {{Admin.date}}  {{Admin.time}}</v-list-tile-sub-title>
                   </v-list-tile-content>
                 </v-list-tile>
               </v-list>
               <v-divider></v-divider>
             </v-card> -->
            <!-- <v-card>ddd{{Notifications}} -->
            <!-- <v-card v-on="on" v-for="(Admin,index) in Notifications" :key="Admin.id">
              <v-list>
                <v-list-tile avatar>
                  <v-list-tile-avatar>
                    <v-img v-bind:src="Admin.user_image"> </v-img>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title class="f-15 font-weight-regular">{{Admin.message}}</v-list-tile-title>
                    <v-list-tile-sub-title class="f-12 grey--text">
                      <span>{{Admin.date}}</span> <span class="text-primary opacity--7"> {{Admin.time}}</span></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider class="grey lighten-5"></v-divider>
            </v-card> -->
            <!-- <v-flex v-if="Notifications.length!=0 && NextNotificationUrl!=null">
              <div v-if="!notiLoading" @click="loadMoreNotifications" style="background-color:#0057a5;color:white;padding:2px 6px;text-align:center;">
                <button>Load More</button>
              </div>
              <div v-if="notiLoading" style="background-color:white;text-align:center;width:100%;padding:2px 10px;">
                <scale-loader :loading="true" color="#005daa" height="25px"></scale-loader>
              </div>
            </v-flex>
          </div> -->
        <!-- </v-menu> -->
        <!-- <v-menu
          v-model="menuu"
          :close-on-content-click="false"
          :nudge-width="300"
          offset-x
          class="right"
        >
          <v-btn small class="white" icon slot="activator">
            <v-icon class="textColor f-28" @click="menuu = true">public</v-icon>
          </v-btn>
          <div style="height:500px !important;">
            <v-card v-for="Admin in AdminRequest" :key="Admin.id">
              <v-list >
                <v-list-tile avatar>
                  <v-list-tile-avatar>
                    <v-img v-bind:src="Admin.user_image"> </v-img>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{Admin.message}}</v-list-tile-title>
                    <v-list-tile-sub-title> {{Admin.date}}  {{Admin.time}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider></v-divider>
            </v-card>
          </div>
        </v-menu> -->

        <v-tooltip bottom>
          <span>Notification</span>
        </v-tooltip>
      </v-toolbar>

      <v-navigation-drawer width="420" right overlay height="88vh"  class="pa-2 mb-3 card-r pb-4 shadow-1 grey lighten-4" fixed dark v-model="drawer">
          <!--<v-card >-->
            <v-toolbar class="primary card-r pl-3 mb-3 text-white">
              <div class="text-xs-left f-20">Notifications</div>
              <v-spacer></v-spacer>
              <v-btn small class="mr-3 primary green" icon @click="drawer = false">
                <v-icon class="text-white f-28">close</v-icon>
              </v-btn>
            </v-toolbar>
                <v-card v-for="(Admin,index) in Notifications" :key="Admin.id" class="white card-r mb-2">
                  <v-list >
                    <v-list-tile avatar>
                      <v-list-tile-avatar>
                        <v-img v-bind:src="Admin.user_image"> </v-img>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title class="f-12 text-primary font-weight-medium">{{Admin.message}}</v-list-tile-title>
                        <v-list-tile-sub-title class="f-10 grey--text">
                          <span>{{Admin.date}}</span><v-spacer></v-spacer><span class="grey--text"> {{Admin.time}}</span>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <!--<v-divider class="grey lighten-5"></v-divider>-->
                </v-card>
                <v-flex v-if="Notifications.length!=0 && NextNotificationUrl!=null">
                  <div v-if="!notiLoading" @click="loadMoreNotifications" class="card-r py-2 text-xs-center text-white primary">
                    <button>View More</button>
                  </div>
                  <div v-if="notiLoading" style="background-color:white;text-align:center;width:100%;padding:2px 10px;">
                    <scale-loader :loading="notiLoading" color="#005daa" height="20px"></scale-loader>
                    <!-- <pulse-loader :loading="notiLoading" :color="color" :size="size"></pulse-loader> -->

                  </div>
                </v-flex>
          <!--</v-card>-->
        </v-navigation-drawer>

      <v-content>
        <router-view />
      </v-content>
    </template>
  </v-app>
</template>

<script>
  /* eslint-disable */
  import { mapState } from "vuex";
  import auth from "./utils/auth";
  import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

  // import Pusher from 'pusher-js';

  export default {
    data() {
      return {
        deleted : '',
        select: { state: 'English ', abbr: 'FL' },
        drawer: false,
        itssems: [
          { title: 'Home', icon: 'dashboard' },
          { title: 'About', icon: 'question_answer' },
        ],
        items: [
          { state: 'Chinese', abbr: 'FL' },
          { state: 'English ', abbr: 'GA' },
          { state: 'Hindustani ', abbr: 'NE' },
          { state: 'Spanish ', abbr: 'CA' },
          { state: 'Malay  ', abbr: 'CA' },
          { state: 'Russian ', abbr: 'CA' },
          { state: 'Bengali  ', abbr: 'CA' },
          { state: 'Danish ', abbr: 'CA' },
          { state: 'Tamil ', abbr: 'CA' },
          { state: 'Arabic ', abbr: 'NY' }
        ],
        loggedIn: auth.loggedIn(),
        // menuu: false,
        menu:false,
        right: null,
        logo: '/static/logo2.png',
        SidebarStatus:'',
        notificationData:[],
        AdminRequest:[],
        notiLoading:'',
      }
    },
    computed: {
      ...mapState({
        user: "user",
        sideNav:"sideNav",
        Notifications: Notifications => Store.state.Notifications,
        NextNotificationUrl: Notifications => Store.state.NextNotificationUrl
      }),
      auth() {
        return auth;
      },
    },
    beforeCreate() {
    },
    created() {
      Store.dispatch('getAllNotifications')
      auth.onChange = loggedIn => {
        console.log("loggedIn", loggedIn);
        this.loggedIn = loggedIn;
      };
      //  [App.vue specific] When App.vue is first loaded start the progress bar
      this.$Progress.start();

      //  hook the progress bar to start before we move router-view
      this.$router.beforeEach((to, from, next) => {
        //  does the page we want to go to have a meta.progress object
        if (to.meta.progress !== undefined) {
          let meta = to.meta.progress;
          // parse meta tags
          this.$Progress.parseMeta(meta);
          //
        }
        //  start the progress bar
        this.$Progress.start();
        //  continue to next page
        next();
      });
      //  hook the progress bar to finish after we've finished moving router-view
      this.$router.afterEach((to, from) => {
        if (to.name !== "ErrorPage") {
          this.menuItem = to.name;
        }
        //  finish the progress bar
        this.$Progress.finish();
      });


      // Store.dispatch("GetAllRequest").then(
      //   res => {
      //     console.log("GetAllRequest success");

      //     var RequestsData = res.data.data;


      //     var TempArray = [];
      //       for (var i = 0; i < RequestsData.length; i++) {
      //         TempArray.push({
      //           id: RequestsData[i].id,
      //           user_id: RequestsData[i].user_id,
      //           // admin_id: RequestsData[i].admin_id,
      //           // admin_name: RequestsData[i].admin_name,
      //           // admin_email: RequestsData[i].admin_email,
      //           // club_name: RequestsData[i].club_name,
      //           date: RequestsData[i].date,
      //           time: RequestsData[i].time,
      //           type: RequestsData[i].type,
      //           message: RequestsData[i].message,
      //           user_name: RequestsData[i].user_name,
      //           user_image: RequestsData[i].user_image,
      //           // status: RequestsData[i].status
      //         });
      //       }

      //     this.AdminRequest = TempArray;
      //     Store.state.AdminRequest = TempArray;
      //     console.log(this.AdminRequest);
      //   }).catch(error=>{
      //     console.log(error);

      //     this.$notify({
      //       group: "error",
      //       type: "error",
      //       text: error.message
      //     });
      //   }
      // );
    },
    mounted:function(){
          var config = {
            messagingSenderId: "1087400853618"
          };
          firebase.initializeApp(config);
          const messaging = firebase.messaging();

          // Request for permission
          messaging.requestPermission()
          .then(function() {
            console.log('Notification permission granted.');
            // TODO(developer): Retrieve an Instance ID token for use with FCM.
            messaging.getToken()
            .then(function(currentToken) {
              if (currentToken) {
                console.log('Token: ' + currentToken)
                localStorage.setItem('device_token',currentToken)
              } else {
                console.log('No Instance ID token available. Request permission to generate one.');
              }
            })
            .catch(function(err) {
              console.log('An error occurred while retrieving token. ', err);
            });
          })
          .catch(function(err) {
            console.log('Unable to get permission to notify.', err);
          });


          messaging.onMessage(function(payload) {
            console.log("Notification received: ", payload);
            Store.dispatch('pushLiveNotification',payload.data)
          });

        // var el = document.getElementById('#notificationWindow')
        // console.log(el)
        // el.scrollTop = el.scrollHeight

        // this.pusher=new Pusher('e9455c16bc5f0d6c4547',{
        //   cluster: 'ap2',
        //   encrypted: true,
        //   disableStats: true,
        // })
        // let self=this
        // let pusherToken=Store.state.pusherToken
        //  this.channel=this.pusher.subscribe(pusherToken);
        // let notificationData=Store.state.notificationData
    },
    methods:{
      logout(){
        this.deleted=false
        this.$router.push('/logout')
      },
      loadMoreNotifications(){
        this.notiLoading=true
        console.log("loadMoreNotifications")
        Store.dispatch('callNextNotifications')
        setTimeout(()=>{
          this.notiLoading=false
        },1000);
      },
      ChangeSidebar(){
        if(this.sideNav){
          Store.state.sideNav=false;
        }else{
          Store.state.sideNav=true;
        }
      }
    },
    name: 'App',
    components: {
      ScaleLoader
    }
  }
</script>

<style>
  @import './css/main.css';
 .nav-ico .v-list__group__header .v-list__group__header__prepend-icon {
    display: -webkit-box;
    color: white !important;
  }
  /* @import 'vue-dawa/dist/vue-dawa.min.css'; */
  body .display-1, .headline{
    font-family: 'arial', sans-serif !important;
    /*font-size: 14px;*/
  }
  .topborder{
    border-top: 3px solid #2196f3 !important;
    /* font-size:100px; */
  }
  /*.dri-bgcolour{*/
  /*background-color: #efeff6;*/
  /*}*/
  .dri-shadow{
    border: none;
    -webkit-box-shadow: 0px 1px 2px 1px rgba(154, 154, 204, 0.22);
    -moz-box-shadow: 0px 1px 2px 1px rgba(154, 154, 204, 0.22);
    box-shadow: 0px 1px 2px 1px rgba(154, 154, 204, 0.22);
  }
  button:focus {outline:0;}
  .fa, .fas, .far, .fal, .fab{
    /*font-size: 20px !important;*/
  }
  .main ::-webkit-scrollbar {
    display: none!important;
  }
 .nav-scrl::-webkit-scrollbar{
    display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue